export default "__VITE_ASSET__kuhcrJrF__"